import { getDeviceType } from '../../helpers/browser';
import { subscribeToDeviceChanging } from '../../observer/deviceObserver';
import dom from '../../wrapper/DomWrapper';

import { SHAPE_POSITIONS } from './constants';
import { checkIsMobileMode, getBackgroundStyles } from './utils';

class PanelWidget {
  constructor(widget) {
    this.widget = widget;
  }

  init = () => {
    this.settings = JSON.parse(this.widget.dataset.settings);

    this.resize();

    subscribeToDeviceChanging(this.widget, (device) => this.resize(device));
  };

  resize = (currentDevice) => {
    const {
      itemSize,
      shapeElementsLength,
      position,
      backgroundSize,
    } = this.settings;
    const device = currentDevice || getDeviceType();
    const isMobileMode = checkIsMobileMode({
      shapeElementsLength,
      itemSize,
      device,
    });

    if (isMobileMode && position !== SHAPE_POSITIONS.FILL) {
      dom.addClass(this.widget, 'shape-bg-position');
      dom.addClass(this.widget, `_${position.toLowerCase()}`);
    } else {
      dom.removeClass(this.widget, 'shape-bg-position');
      dom.removeClass(this.widget, `_${position.toLowerCase()}`);
    }

    const bgStyles = getBackgroundStyles({
      position,
      backgroundSize,
      device,
      isMobileMode,
    });

    const elBgImage = dom.getElement('.section_bg-img', this.widget);

    if (!elBgImage || !bgStyles) return;

    dom.updateStyle(elBgImage, bgStyles);
  };
}

export default PanelWidget;
